<!--
 * @Descripttion: 
 * @version: v1.0.0
 * @Author: zhoumin
 * @Date: 2020-08-27 11:05:23
 * @LastEditors: zhoumin
 * @LastEditTime: 2020-09-27 15:55:20
-->
<template>
  <div class="Notice">
    <h2>关于举办山西省第十四届职业院校技能大赛中等职业学校班主任能力比赛的通知</h2>
    <section>
      <object type="application/pdf" :data="url" id="review" style="width:100%;  height:900px;"></object>
    </section>
    <section class='file'>
      <h3>附件下载：</h3>
      <p v-for="(item, i) in list" :key="i">
        <a :href="item.link" @click="downLoad(item)">{{item.name}}</a>
      </p>
    </section>
  </div>

</template>

<script>
export default {
  name: "Notice",
  data() {
    return {
      url: "",
      list: [
        {
          name: "附件1：业务能力组参赛材料及有关要求",
          url: "f14b6dc9423c440587fcacd081f1e8a1.docx"
        },
        {
          name: "附件2：业务能力组决赛安排及要求.docx",
          url: "8f77696591f449119813fe41f3958166.docx"
        },
        {
          name:
            "附件3：全省中等职业学校班主任大赛业务能力组各市及省属学校参赛名额分配表.docx",
          url: "82c759c193314716b1c813521e1732a6.docx"
        },
        {
          name: "附件4：业务能力组参赛报名表.docx",
          url: "810346e0dc6745c68b1e03c684622e24.docx"
        },
        {
          name: "附件5：业务能力组参赛汇总表.docx",
          url: "f1289494af66498883a4f5066643595b.docx"
        },
        {
          name: "附件6：业务能力组评分指标.docx",
          url: "fa131da804ae4072b7b3dfc8fefc04d1.docx"
        },
        {
          name: "附件7：“最美中职班主任”组参赛推荐表.docx",
          url: "c8b7c1ab01ef417f83f4b1bc64992d07.docx"
        },
        {
          name: "附件8：“最美中职班主任”组参赛材料及有关要求.docx",
          url: "059fe83eb98746eda9d8775fa85190e3.docx"
        }
      ]
    };
  },
  methods: {
    downLoad(item) {
      this.$utils.downloadFile(item.url, item.name);
    },
    back() {
      if (this.backing) {
        return;
      }
      this.backing = true;
      this.$router.go(-1);
    }
  },
  created() {
    const name = "7cb89d02bc4f448fa3ffcac9661f98fe.pdf";

    this.$utils.getImgUrl(name).then(r => {
      this.url = r;
    });
  }
};
</script>

<style lang="scss" scoped>
.Notice {
  h2 {
    text-align: center;
    font-size: 44px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 62px;
    color: rgba(235, 85, 79, 1);
    padding: 80px 0px 66px 0px;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }
  .file {
    margin-bottom: 120px;
    h3 {
      font-size: 20px;
      padding-top: 80px;
      color: #2d2828;
    }
    a {
      font-size: 16px;
      cursor: pointer;
      &:hover {
        color: #5381ff;
        text-decoration: underline;
      }
    }
  }
}
</style>